import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { hoa_blogs_get_new } from "./Api";
import parse from "html-react-parser";

const SingleBlog = (props) => {
  const [bloglist, setBloglist] = useState({});

  const blogsPerPage = 7;
  const [keyBig, setKeyBig] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const keys = Object.keys(bloglist);
  const totalPages = Math.ceil(keys.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;

  const getBlogList = () => {
    hoa_blogs_get_new().then((res) => {
      console.log("bloglist", res);
      try {
        if (res.status === "successfull") {
          setBloglist(res.result);
      
        } else {
            console.log(res.message)
        }
      } catch {
       console.log('Something went wrong')
      }
    });
  };
  useEffect(() => {
    getBlogList();
  }, []);

  const handleBlogKey=(index)=>{
          setKeyBig(index)
    }
  const currentBlogs = keys.slice(startIndex, startIndex + blogsPerPage);

  return (
    <>
      <Navbar />

      {Object.keys(bloglist).length > 0 ? (
        <div className="BlogPage">
          <div className="row">
            <div className="col-md-8">
              <div>
                <div className="blogImgbig">
                  <img
                    src={"data:image/png;base64," + bloglist[keyBig].image}
                    alt=""
                  />
                </div>
                <div className="blogTitlebig">{bloglist[keyBig].title}</div>
                <div className="singleBlogDesc">{parse(bloglist[keyBig].value)}</div>
              </div>
            </div>
            <div className="col-md-4">
              {currentBlogs.map((key) => (
                <div className="blogBox" key={key}  onClick={() => handleBlogKey(key)}>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="blogImg">
                        <img
                          src={"data:image/png;base64," + bloglist[key].image}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="blogTitle">{bloglist[key].title}</div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="pagination">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Prev</button>

                <span>Page {currentPage} of {totalPages}</span>

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          {/* <div className='articleDiv'>Did you find this article helpful? 
                <span className='articleSpan'>
                    <MDBIcon fas icon="thumbs-up" className={like?'thumbIA':'thumbI'} onClick={handleLike}/>
                    <MDBIcon fas icon="thumbs-down" className={dislike?'thumbIA':'thumbI'} onClick={handleDislike}/>
                </span>
            </div> */}
        </div>
      ) : (
        <div style={{height:'60vh'}}>
       <div className="loader"></div>
       </div>
      )}
      <Footer />
    </>
  );
};

export default SingleBlog;
